<template>
  <div class="ruKuZuoyeWarp-body">
    <!-- 转货申请 -->
    <el-dialog width="80%" title="转货申请" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="applyVisible" @close="zhuanhuoDialogclose" center>
      <el-form :inline="true" :model="turnform" class="demo-form-inline" ref="turnform">
        <el-form-item label="转货后一级货主:" :rules="[{required:true,message:'请选择转货后一级货主',trigger:'change'}]">
          <el-select :disabled='trunFlag=="huigou"' v-model="turnform.primaryCustomerTaxId" size="mini"
            placeholder="请选择货主" @change="selectHZ1(turnform)" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转货后二级货主:" :rules="[{required:true,message:'请选择转货后二级货主',trigger:'change'}]">
          <el-select v-model="turnform.customerTaxId" :disabled=disabledTwo @change="selectHZ(turnform)" size="mini"
            placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left:10px;" label="货主转货单编号:"
          :rules="[{required:false,message:'请输入货主转货单编号',trigger:'blur'}]">
          <el-input style="width:172px;" v-model.trim="turnform.customerChangNo" maxlength="50" size="mini"
            placeholder="请输入货主转货单编号"></el-input>
        </el-form-item>
        <div>
          <el-form-item style="margin-left:20px;" v-if="guohuType">
            <el-checkbox-group v-model="turnform.type" @change='changeCheck(turnform)'>
              <el-checkbox label="收取过户费" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item style="margin-left:20px;" label="结算客户:" v-if="checkFlag&&jiesuanFlag"
            :rules="[{required:true,message:'请选择结算客户',trigger:'change'}]">
            <el-select v-model="turnform.payCustomerTaxId" @change="selectHZ3(turnform)" size="mini"
              placeholder="请选择结算客户" filterable clearable>
              <el-option v-for="(item, index) in jiesuanData" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 结算显示 -->
        <div v-if="checkFlag&&jiesuanFlag">
          <el-table :data="oneAndTwo" ref="oneAndTwo" border bordersize="mini" style="width: 100%;margin-top:10px;"
            center :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}"
            :row-style="{height:'35px'}" highlight-current-row>
            <el-table-column prop="fyType" label="费用类型" align="center" width="120"></el-table-column>
            <el-table-column prop="instockDate" label="入库日期" align="center" width="120"></el-table-column>

            <!-- <el-table-column prop="" label="货权剩余" align="center" width="150" ></el-table-column> -->
            <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
            <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
            <el-table-column prop="specification" label="规格" width="130" align="center"></el-table-column>
            <el-table-column prop="model" label="材质" align="center"></el-table-column>
            <el-table-column prop="changeNumber" label="件数" align="center"></el-table-column>
            <el-table-column prop="changeWeight" label="总重量(吨)" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价(元/吨)" align="center">
              <template
                v-slot="scope">{{scope.row.unitPrice==0?0:scope.row.unitPrice?scope.row.unitPrice:'-'}}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额(元)" align="center">
              <template
                v-slot="scope">{{scope.row.feeAmount==0?0:scope.row.feeAmount?scope.row.feeAmount:'-'}}
              </template>

            </el-table-column>
       
          </el-table>
        </div>
      </el-form>
      <div slot="footer" style="width:300px;margin:15px auto;">
        <el-button @click="zhuanhuoDialogclose" size='mini'>取 消</el-button>
        <el-button type="primary" @click="jiesuanZH" size='mini' v-if="checkFlag&&jiesuanFlag">结算并转货</el-button>
        <el-button type="primary" @click="zhuanhuoSave('turnform')" size='mini'>保 存</el-button>
      </div>
    </el-dialog>
    <jie-suan v-if="jiesuanVisible" :jiesuanVisible.sync="jiesuanVisible" :title="jiesuanTitle" :titleFlag="titleFlag"
      :customer=turnform.payCustomerName :customerTaxid=turnform.payCustomerTaxId :params=obj1
      @colseDialog="colseDialog" :totalFee=feeHJ :weiHJ=weiHJ>
    </jie-suan>
  </div>
</template>

<script>
  import {
    addEmptyChangeDaily,
    checkZkdJcFeeNameYesOrNo,
    getTransferCostUnitPrice,
  } from '@/api/wms-stock'
  import DonMessage from '@/utils/message'
  import {
    exportExcel
  } from '@/utils/fileDown.js'
  import {
    getBtn
  } from '@/utils/getButton'
  import daoru from './daoru.vue'
  import jieSuan from '../../jiesuanDialog.vue'

  export default {
    props: {
      JfgetStockCustomerLists: {
        type: Function
      },
      RKData: {
        type: Array
      },
      isReminder: {
        type: Number
      },
      oneAndTwo: {
        type: Array
      },
      oneAndTwo1: {
        type: Array
      },
      applyVisible: {
        type: Boolean,
        default: false
      },
      turnMark: {
        type: Boolean,
        default: false
      },
    },
    components: {
      daoru,
      jieSuan
    },
    name: 'kehuKucun',
    data() {
      return {
        jiesuanTitle: '结算并转货',
        titleFlag: '每日库存',
        feeHJ: '',
        weiHJ: '',
        jiesuanData: [],
        danjiaList: [],
        obj1: {},
        turnform: {
          type: [],
          primaryCustomerTaxId: '',
          customerTaxId: '',
          customerChangNo: ''
        },
        jiesuanFlag: false,
        guohuType: false,
        jiesuanVisible: false,
        checkFlag: false,
        disabledTwo: true,
        showBianhao: false,
        // applyVisible: false,
        trunFlag: 'zhuanhuo',
      }
    },
    mounted() {

    },
    created() {

    },
    methods: {
      colseDialog(val) {
        this.$emit('sendmsg')
        this.jiesuanVisible = val
      },
      // 结算并转货
      getmsg(val) {
        console.log(val, 'jiesuanParams')
      },
      // 结算并转货
      jiesuanZH() {
        if (this.turnform.type.length !== 0 && this.jiesuanFlag) {
          // 收取过户费
          let a = 0
          let arr = []
          let arr1 = []
          for (let index = 0; index < this.oneAndTwo.length; index++) {
            const i = this.oneAndTwo[index];
            if (i.unitPrice == null || i.unitPrice == '-' && i.unitPrice !== 0) {

              a = 1
            } else {
              arr.push(i.feeAmount)
              arr1.push(i.changeWeight)
            }
          }
          if (a == 1) {
            DonMessage.error('没有找到单价信息，无法转货')
          } else {
            let newPrimaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
              .primaryCustomerTaxId)[0].custerName
            let newSecondaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
              .customerTaxId)[0].custerName
            this.jiesuanVisible = true
            this.feeHJ = eval(arr.join('+')).toFixed(4)
            this.weiHJ = eval(arr1.join('+')).toFixed(4)
            // 收取过户费
            this.obj1 = {
              payFlag: 1, // 收取过户费标识 （勾选收取过户费时时必填） 1 收取过户费 0不收
              changeMode: 1, //  过户模式（勾选收取过户费时必填）1 结算转货 2 确认转货
              payCustomerName: this.turnform.payCustomerName, //  结算客户（勾选收取过户费时必填）
              payCustomerTaxId: this.turnform.payCustomerTaxId, //  结算客户纳税人识别号（勾选收取过户费时必填）
              changeDetailList: this.oneAndTwo, //  建材货物信息List
              newPrimaryCustomerName: newPrimaryCustomerName,
              newPrimaryCustomerId: this.turnform.primaryCustomerTaxId,
              newSecondaryCustomerName: newSecondaryCustomerName,
              newSecondaryCustomerId: this.turnform.customerTaxId,
              oldPrimaryCustomerName: this.oneAndTwo[0].primaryCustomerName,
              oldPrimaryCustomerId: this.oneAndTwo[0].primaryCustomerTaxId,
              oldSecondaryCustomerName: this.oneAndTwo[0].customerName,
              oldSecondaryCustomerId: this.oneAndTwo[0].customerTaxId,
              changeType: 1,
              allWeightTotal: this.weiHJ,
              cargoControlKey: this.oneAndTwo[0].RowStr,
              customerChangNo: this.turnform.customerChangNo,
              isReminder: this.isReminder,
            }

          }

        } else {
          this.jiesuanVisible = false
          this.obj1 = {
            payFlag: 0, // 收取过户费标识 （勾选收取过户费时时必填） 1 收取过户费 0不收

          }
        }

      },
      // 选中过户费
      changeCheck(form) {
        if (form.type.length !== 0) {
          this.checkFlag = true
          this.jiesuanFlag = true
          // 是否开启结算
          checkZkdJcFeeNameYesOrNo({
              feeName: '过户费',
            })
            .then(res => {
              // 有结算
              if (res == 1) {
                // 获取单价信息
                this.oneAndTwo1.forEach((item, index) => {
                  this.$set(item, 'unitPrice', '')
                  this.$set(item, 'feeAmount', '')
                })
                getTransferCostUnitPrice({
                    payCustomerName: this.turnform.payCustomerName, //结算客户（必填）
                    payCustomerTaxId: this.turnform.payCustomerTaxId, // 结算客户纳税人识别号（必填）
                    tFeeDetailJcList: this.oneAndTwo1, // 建材货物信息List（必填）
                  })
                  .then(res => {
                    // 已配置过户费
                    if (res.length !== 0) {
                      // this.guohuType = true

                      res.forEach(item1 => {
                        this.oneAndTwo.forEach((item2, index2) => {
                          if (item1.businessId == item2.businessId) {
                            this.$set(item2, 'unitPrice', item1.unitPrice)
                            this.$set(item2, 'feeAmount', item1.feeAmount)
                          }
                        });
                      });
                    } else {
                      this.oneAndTwo.forEach((item2, index2) => {
                        this.$set(item2, 'unitPrice', '-')
                        this.$set(item2, 'feeAmount', '-')
                      });
                      // this.guohuType = false
                    }
                    console.log(this.oneAndTwo,'this.oneAndTwo')
                  })
                  .catch(err => {
                    // this.guohuType = false

                    this.oneAndTwo.forEach((item2, index2) => {
                      this.$set(item2, 'unitPrice', '-')
                      this.$set(item2, 'feeAmount', '-')
                    });
                  })
              } else {}
            })
            .catch(err => {})
        } else {
          this.checkFlag = false
          this.jiesuanFlag = false
        }
      },
      selectHZ1(form) {
        if (form.primaryCustomerTaxId !== '' && form.customerTaxId == '') {
          this.disabledTwo = false

        } else if (form.primaryCustomerTaxId !== '' && form.customerTaxId !== '') {
          this.jiesuanData = []
          let obj1 = {
            id: this.oneAndTwo[0].customerTaxId,
            name: this.oneAndTwo[0].customerName
          }
          let obj2 = {
            id: this.oneAndTwo[0].primaryCustomerTaxId,
            name: this.oneAndTwo[0].primaryCustomerName
          }
          let obj3 = {
            id: form.primaryCustomerTaxId,
            name: this.RKData.filter(item => item.taxpayerNumber == this.turnform.primaryCustomerTaxId)[0]
              .custerName
          }
          let obj4 = {
            id: form.customerTaxId,
            name: this.RKData.filter(item => item.taxpayerNumber == this.turnform.customerTaxId)[0].custerName
          }
          let arr = []
          arr.push(obj1, obj2, obj3, obj4)
          let arr1 = arr
          let deWeightThree = () => {
            let name = 'name';
            let map = new Map();
            for (let item of arr1) {
              if (!map.has(item.name)) {
                map.set(item.name, item);
              }
            }
            return [...map.values()];
          }
          this.jiesuanData = deWeightThree();
          console.log(this.jiesuanData, 'this.jiesuanData')
        } else {
          this.disabledTwo = true
          form.customerTaxId = ''
          this.jiesuanData = []
          this.jiesuanFlag = false

        }

      },
      selectHZ3(form) {
        form.payCustomerName = this.jiesuanData.filter(item => item.id == form.payCustomerTaxId)[0].name
        this.oneAndTwo1.forEach((item, index) => {
          this.$set(item, 'unitPrice', '')
          this.$set(item, 'feeAmount', '')
        })
        console.log(this.oneAndTwo1, 'this.oneAndTwo1')

        getTransferCostUnitPrice({
            payCustomerName: this.turnform.payCustomerName, //结算客户（必填）
            payCustomerTaxId: this.turnform.payCustomerTaxId, // 结算客户纳税人识别号（必填）
            tFeeDetailJcList: this.oneAndTwo1, // 建材货物信息List（必填）
          })
          .then(res => {
            // 已配置过户费
            if (res.length !== 0) {
              res.forEach(item1 => {
                this.oneAndTwo.forEach((item2, index2) => {
                  if (item1.businessId == item2.businessId) {
                    this.$set(item2, 'unitPrice', item1.unitPrice)
                    this.$set(item2, 'feeAmount', item1.feeAmount)
                  }
                });
              });
            } else {
              this.oneAndTwo.forEach((item2, index2) => {
                this.$set(item2, 'unitPrice', '-')
                this.$set(item2, 'feeAmount', '-')
              });
            }
          })
          .catch(err => {
            this.oneAndTwo.forEach((item2, index2) => {
              this.$set(item2, 'unitPrice', '-')
              this.$set(item2, 'feeAmount', '-')
            });
          })
        this.$forceUpdate()
      },
      // 选中二级货主
      selectHZ(form) {
        if (form.customerTaxId == '') {
          this.$message({
            message: '请选择二级货主',
            type: 'error'
          })
          this.checkFlag = false
          this.jiesuanFlag = false
          this.turnform.type = []

        } else {
          this.checkFlag = false
          this.jiesuanFlag = false
          this.turnform.type = []

          this.turnform.type = []
          this.turnform.payCustomerTaxId = form.customerTaxId
          this.turnform.payCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
            .payCustomerTaxId)[0].custerName
          this.oneAndTwo.forEach((item, index) => {
            item.businessId = item.dailyStockSummaryId
            item.weight = item.changeWeight
            item.fyType = '过户费'
          })
          // 是否开启结算
          checkZkdJcFeeNameYesOrNo({
              feeName: '过户费',
            })
            .then(res => {
              // 有结算
              if (res == 1) {
                this.jiesuanFlag = false
                this.guohuType = true

                this.turnform.type = []
                let obj1 = {
                  id: this.oneAndTwo[0].customerTaxId,
                  name: this.oneAndTwo[0].customerName
                }
                let obj2 = {
                  id: this.oneAndTwo[0].primaryCustomerTaxId,
                  name: this.oneAndTwo[0].primaryCustomerName
                }
                let obj3 = {
                  id: form.primaryCustomerTaxId,
                  name: this.RKData.filter(item => item.taxpayerNumber == this.turnform.primaryCustomerTaxId)[0]
                    .custerName
                }
                let obj4 = {
                  id: form.customerTaxId,
                  name: this.RKData.filter(item => item.taxpayerNumber == this.turnform.customerTaxId)[0].custerName
                }
                let arr = []
                arr.push(obj1, obj2, obj3, obj4)
                let arr1 = arr
                let deWeightThree = () => {
                  let name = 'name';
                  let map = new Map();
                  for (let item of arr1) {
                    if (!map.has(item.name)) {
                      map.set(item.name, item);
                    }
                  }
                  return [...map.values()];
                }
                this.jiesuanData = deWeightThree();
                // 获取单价信息
                // 获取单价信息
                this.oneAndTwo1.forEach((item, index) => {
                  this.$set(item, 'unitPrice', '')
                  this.$set(item, 'feeAmount', '')
                })
                getTransferCostUnitPrice({
                    payCustomerName: this.turnform.payCustomerName, //结算客户（必填）
                    payCustomerTaxId: this.turnform.payCustomerTaxId, // 结算客户纳税人识别号（必填）
                    tFeeDetailJcList: this.oneAndTwo1, // 建材货物信息List（必填）
                  })
                  .then(res => {
                    // 已配置过户费

                    if (res.length !== 0) {
                      res.forEach(item1 => {
                        this.oneAndTwo.forEach((item2, index2) => {
                          if (item1.businessId == item2.businessId) {
                            this.$set(item2, 'unitPrice', item1.unitPrice)
                            this.$set(item2, 'feeAmount', item1.feeAmount)
                          }
                        });
                      });
                    } else {
                      this.oneAndTwo.forEach((item2, index2) => {
                        this.$set(item2, 'unitPrice', '-')
                        this.$set(item2, 'feeAmount', '-')
                      });
                      // this.guohuType = false
                    }
                  })
                  .catch(err => {
                    // this.guohuType = false

                    this.oneAndTwo.forEach((item2, index2) => {
                      this.$set(item2, 'unitPrice', '-')
                      this.$set(item2, 'feeAmount', '-')
                    });
                  })

              } else {
                this.jiesuanFlag = false
                this.guohuType = false
                this.turnform.type = []
              }
            })
            .catch(err => {
              this.$message({
                message: err.message,
                type: 'error'
              })
            })

        }



      },
      zhuanhuoDialogclose() {
        // loading.close()

        // this.applyVisible = false
        this.$emit('update:applyVisible', false)

      },
      zhuanhuoSave(formName) {
        if (this.turnform.primaryCustomerTaxId == '') {

          DonMessage.error('转货后一级货主不能为空')
          return
        } else if (this.turnform.customerTaxId == '') {
          DonMessage.error('转货后二级货主不能为空')
          return

        }
        // 1..在原有逻辑上增加以下逻辑：如果有收取转货费，判断费用信息列表中的单价是否为空，如果为空，提示“没有找到单价信息，无法转货”，否则，正常转货；
        //  2.如果有收取转货费，转货成功后生成计费明细，状态为未收款。
        if (this.turnform.type.length !== 0 && this.jiesuanFlag) {
          // 收取过户费
          let a = 0
          let arr = []
          let arr1 = []
          for (let index = 0; index < this.oneAndTwo.length; index++) {
            const i = this.oneAndTwo[index];
            if (i.unitPrice == null || i.unitPrice == '-' && i.unitPrice !== 0) {
              a = 1
            } else {
              arr.push(i.feeAmount)
              arr1.push(i.changeWeight)
            }
          }
          if (a == 1) {
            DonMessage.error('没有找到单价信息，无法转货')
          } else {
            this.feeHJ = eval(arr.join('+')).toFixed(4)
            this.weiHJ = eval(arr1.join('+')).toFixed(4)
            this.zhuanhouOk()

          }
        } else {
          this.zhuanhouOk()
        }



      },
      // 确认转货
      zhuanhouOk() {

        let newPrimaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
          .primaryCustomerTaxId)[0].custerName
        let newSecondaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
          .customerTaxId)[0].custerName
        let changeType = 1
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        console.log(this.oneAndTwo[0])
        let obj
        let arrs = this.oneAndTwo[0].RowStr.split('|')
        console.log(arrs)
        if (arrs.length == 4) {
          obj = {
            primaryCustomerTaxId: this.oneAndTwo[0].primaryCustomerTaxId,
            customerTaxId: this.oneAndTwo[0].customerTaxId,
            steelMillName: arrs[0],
            productType: arrs[1],
            specification: arrs[2],
            model: arrs[3]
          }
        }

        console.log(obj)
        let obj1

        if (this.turnform.type.length !== 0 && this.jiesuanFlag) {
          // 收取过户费
          obj1 = {
            payFlag: 1, // 收取过户费标识 （勾选收取过户费时时必填） 1 收取过户费 0不收
            changeMode: 2, //  过户模式（勾选收取过户费时必填）1 结算转货 2 确认转货
            payCustomerName: this.turnform.payCustomerName, //  结算客户（勾选收取过户费时必填）
            payCustomerTaxId: this.turnform.payCustomerTaxId, //  结算客户纳税人识别号（勾选收取过户费时必填）
            changeDetailList: this.oneAndTwo, //  建材货物信息List
            allFeeTotal: this.feeHJ, // 费用合计（有费用信息必填）
            allWeightTotal: this.weiHJ, //  总重量合计（有费用信息必填）
            //  unitPrice 单价 （勾选收取过户费时必填） 
            //  feeAmount 金额（勾选收取过户费时必填）
          }
        } else {
          obj1 = {
            payFlag: 0, // 收取过户费标识 （勾选收取过户费时时必填） 1 收取过户费 0不收

          }
        }
        addEmptyChangeDaily({
            newPrimaryCustomerName: newPrimaryCustomerName,
            newPrimaryCustomerId: this.turnform.primaryCustomerTaxId,
            newSecondaryCustomerName: newSecondaryCustomerName,
            newSecondaryCustomerId: this.turnform.customerTaxId,
            oldPrimaryCustomerName: this.oneAndTwo[0].primaryCustomerName,
            oldPrimaryCustomerId: this.oneAndTwo[0].primaryCustomerTaxId,
            oldSecondaryCustomerName: this.oneAndTwo[0].customerName,
            oldSecondaryCustomerId: this.oneAndTwo[0].customerTaxId,
            changeType: changeType,
            cargoControlKey: this.oneAndTwo[0].RowStr,
            changeDetailList: this.oneAndTwo,
            customerChangNo: this.turnform.customerChangNo,
            isReminder: this.isReminder,
            ...obj,
            ...obj1
          })
          .then(res => {
            loading.close()

            console.log(res)
            this.$message({
              message: '转货成功',
              type: 'success'
            })
            this.$emit('sendmsg')
          })
          .catch(err => {
            loading.close()

            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }
    }

  }

</script>

<style lang='less' scoped>
  .messages {
    font-size: 16px;
  }

</style>
